export const LOCAL = "LOCAL";
export const PRE = "PRE";

export const PRO = "PRO";

export const REJECTION_REASON_MIN_CHARACTERS = 1;

export const SPANISH = "Español";
export const CATALAN = "Català";
export const ENGLISH = "English";
export const GERMAN = "Deutsch";
export const FRENCH = "Français";

export const VIDMOBILEUSERID = "vidmobileuserid";

// localStorage keys for VC-sign flow (wallet-based)
export const VC_SIGN_STORAGE_KEYS = {
  QrInfoList: 'VC_SIGN_QrInfoList',
  RequestId: 'VC_SIGN_RequestId',
  SignerGuid: 'VC_SIGN_SignerGuid',
  Certificate: 'VC_SIGN_CertificateSelected',
  paginationMeta: 'VC_SIGN_paginationMeta',
};